export const APP_STORE_URL = "https://apps.apple.com/sa/app/cshaped/id6782850828";
